import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { schedularTherapistFilterAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

function* getSplitTask(action: any): SagaReturnType<any> {
  try {

    yield put({type:schedularTherapistFilterAction.GET_SPLIT_TASK_LOADING})
    const response = yield call(
      therapistSchedulingServices.getSplitTask,
      action.payload
    );
    if (response?.status === 200) {
      yield put({
        type: schedularTherapistFilterAction.GET_SPLIT_TASK_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({
      type: schedularTherapistFilterAction.GET_SPLIT_TASK_FAILURE,
      payload: error,
    });
  }
}

function* getSplitTaskSaga() {
  yield takeEvery(
    schedularTherapistFilterAction.GET_SPLIT_TASK_REQUEST,
    getSplitTask
  );
}

export default getSplitTaskSaga;
